/**
 * EC – Facets (filtering and sorting).
 * Cópia do facets.js do tema com suporte a ec-price-facet e uso junto de ec-facets.liquid.
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.pendingSubmitTimeout = null;

    this.debouncedOnSubmit = (event) => {
      clearTimeout(this.pendingSubmitTimeout);
      this.pendingSubmitTimeout = setTimeout(() => {
        this.onSubmitHandler(event);
      }, 800);
    };

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const applyButton = this.querySelector(".ec-facets-desktop__apply");
    if (applyButton) {
      applyButton.addEventListener("click", (event) => {
        clearTimeout(this.pendingSubmitTimeout);
        this.onSubmitHandler(event);
      });
    }

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id,
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element),
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId,
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter"),
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID),
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details",
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const domElement = document.querySelector(selector);
      if (domElement) domElement.innerHTML = activeFacetsElement.innerHTML;
    });

    /* Pills de filtros ativos dentro do drawer mobile — atualiza para refletir a resposta e esvazia se não houver filtros */
    const drawerActiveFacets = html.querySelector(
      ".mobile-facets__active-facets",
    );
    const drawerActiveFacetsDom = document.querySelector(
      ".mobile-facets__active-facets",
    );
    if (drawerActiveFacetsDom) {
      if (drawerActiveFacets) {
        drawerActiveFacetsDom.innerHTML = drawerActiveFacets.innerHTML;
        drawerActiveFacetsDom.style.display = "";
      } else {
        drawerActiveFacetsDom.innerHTML = "";
        drawerActiveFacetsDom.style.display = "none";
      }
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const domEl = document.querySelector(selector);
      if (domEl) domEl.innerHTML = html.querySelector(selector).innerHTML;
    });

    /* Botões mobile Filtrar/Ordenar: atualiza contador de filtros (ec-mobile-filter-sort-btn__count) e classe --has-count */
    const mobileButtonsContainer = html.querySelector(
      ".ec-mobile-filter-sort-buttons",
    );
    const mobileButtonsContainerDom = document.querySelector(
      ".ec-mobile-filter-sort-buttons",
    );
    if (mobileButtonsContainer && mobileButtonsContainerDom) {
      /* Remove o modal de ordenação antigo do body (ModalDialog é movido para body no connectedCallback).
         Senão o modal antigo, com is-selected desatualizado, continua sendo o que abre. */
      document
        .querySelectorAll("modal-dialog[id^='EcSortModal-']")
        .forEach((modal) => modal.remove());
      mobileButtonsContainerDom.innerHTML = mobileButtonsContainer.innerHTML;
      FacetFiltersForm.bindMobileFilterSortButtons();
    }

    const formMobile = document.getElementById("FacetFiltersFormMobile");
    if (formMobile && formMobile.closest("menu-drawer")) {
      formMobile.closest("menu-drawer").bindEvents();
    }
  }

  /**
   * Revincula os botões mobile "Filtrar por" e "Ordenar por" após atualização do DOM (ex.: após aplicar filtros).
   * Os scripts nos snippets rodam só no load; os nós inseridos via innerHTML ficam sem listeners.
   */
  static bindMobileFilterSortButtons() {
    document
      .querySelectorAll('[data-open-drawer="MobileFacetFiltersDrawer"]')
      .forEach((btn) => {
        btn.addEventListener("click", function () {
          const details = document.getElementById("MobileFacetFiltersDrawer");
          if (details && details.querySelector("summary")) {
            details.querySelector("summary").click();
          }
        });
      });

    document.querySelectorAll("[data-open-sort-modal]").forEach((openBtn) => {
      const selector = openBtn.getAttribute("data-open-sort-modal");
      if (!selector) return;
      const modal = document.querySelector(selector);
      if (!modal || typeof modal.show !== "function") return;
      openBtn.addEventListener("click", function () {
        modal.show(openBtn);
      });
      modal.querySelectorAll("[data-sort-option]").forEach((radio) => {
        radio.addEventListener("change", function () {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("sort_by", this.value);
          FacetFiltersForm.renderPage(searchParams.toString(), null);
          if (typeof modal.hide === "function") modal.hide();
        });
      });
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden"),
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item"),
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetWrap = target.querySelector(".facets-wrap");
    const sourceWrap = source.querySelector(".facets-wrap");
    if (sourceWrap && targetWrap) {
      targetWrap.outerHTML = sourceWrap.outerHTML;
      return;
    }
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");
    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.textInputs = this.querySelectorAll("input.ec-price-facet__input");
    if (this.textInputs.length === 0) {
      this.textInputs = this.querySelectorAll('input[type="text"]');
    }
    this.rangeInputs = this.querySelectorAll(
      "input.ec-price-facet__range-input",
    );
    this.dotLeft = this.querySelector("[data-range-left]");
    this.dotRight = this.querySelector("[data-range-right]");
    if (this.rangeInputs.length === 2) {
      this.initRangeSlider();
    } else if (this.dotLeft && this.dotRight && this.querySelector("[data-range-slider]")) {
      this.initRangeSliderDots();
    }
    this.textInputs.forEach((element) => {
      element.addEventListener("change", this.onTextInputChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  parseReais(str) {
    if (str == null || str === "") return NaN;
    const normalized = String(str).trim().replace(",", ".");
    return Number(normalized);
  }

  formatReaisForInput(num) {
    return Number(num).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  initRangeSlider() {
    const container = this.querySelector(".ec-price-facet--range") || this;
    const rangeMin = Number(container.dataset.rangeMin) || 0;
    const rangeMax = Number(container.dataset.rangeMax) || 0;
    const currencySymbol = container.dataset.currencySymbol || "";
    const fillEl = this.querySelector("[data-range-fill]");
    const labelMin = this.querySelector("[data-range-label-min]");
    const labelMax = this.querySelector("[data-range-label-max]");
    const inputMin = this.querySelector(".ec-price-facet__range-input--min");
    const inputMax = this.querySelector(".ec-price-facet__range-input--max");
    const textMin = this.textInputs[0];
    const textMax = this.textInputs[1];

    const formatPrice = (reais) => {
      return (
        currencySymbol +
        " " +
        Number(reais).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    };

    const trackWrap = container.querySelector(".ec-price-facet__range-track-wrap");

    const updateFillAndLabels = (minVal, maxVal) => {
      const range = rangeMax - rangeMin || 0.01;
      const fillLeft = ((minVal - rangeMin) / range) * 100;
      const fillWidth = ((maxVal - minVal) / range) * 100;
      const fillLeftPercent = fillLeft + "%";
      const fillWidthPercent = fillWidth + "%";
      if (fillEl) {
        fillEl.style.setProperty("--range-fill-left", fillLeftPercent);
        fillEl.style.setProperty("--range-fill-width", fillWidthPercent);
      }
      if (trackWrap) {
        trackWrap.style.setProperty("--range-fill-left", fillLeftPercent);
        trackWrap.style.setProperty("--range-fill-width", fillWidthPercent);
      }
      if (labelMin) labelMin.textContent = formatPrice(minVal);
      if (labelMax) labelMax.textContent = formatPrice(maxVal);
    };

    const updateRangeDisplay = () => {
      let minVal = Number(inputMin.value);
      let maxVal = Number(inputMax.value);
      if (minVal > maxVal) {
        const t = minVal;
        minVal = maxVal;
        maxVal = t;
        inputMin.value = minVal;
        inputMax.value = maxVal;
      }
      updateFillAndLabels(minVal, maxVal);
      if (textMin) textMin.value = this.formatReaisForInput(minVal);
      if (textMax) textMax.value = this.formatReaisForInput(maxVal);
    };

    /* Texto → slider: atualiza range, barra e labels em tempo real, sem sobrescrever o que o usuário está digitando */
    const syncTextToRange = () => {
      const minReais = this.parseReais(textMin && textMin.value);
      const maxReais = this.parseReais(textMax && textMax.value);
      let minVal = Number(inputMin.value);
      let maxVal = Number(inputMax.value);
      if (!Number.isNaN(minReais)) {
        minVal = Math.max(rangeMin, Math.min(rangeMax, minReais));
        inputMin.value = minVal;
      }
      if (!Number.isNaN(maxReais)) {
        maxVal = Math.max(rangeMin, Math.min(rangeMax, maxReais));
        inputMax.value = maxVal;
      }
      if (minVal > maxVal) {
        const t = minVal;
        minVal = maxVal;
        maxVal = t;
        inputMin.value = minVal;
        inputMax.value = maxVal;
      }
      updateFillAndLabels(minVal, maxVal);
    };

    [inputMin, inputMax].forEach((input) => {
      input.addEventListener("input", updateRangeDisplay);
    });
    if (textMin) textMin.addEventListener("input", syncTextToRange);
    if (textMax) textMax.addEventListener("input", syncTextToRange);
    updateRangeDisplay();
  }

  initRangeSliderDots() {
    const container = this.querySelector(".ec-price-facet--range") || this;
    const rangeMin = Number(container.dataset.rangeMin) || 0;
    const rangeMax = Number(container.dataset.rangeMax) || 0;
    const range = rangeMax - rangeMin || 0.01;
    const currencySymbol = container.dataset.currencySymbol || "";
    const sliderEl = this.querySelector("[data-range-slider]");
    const dotLeft = this.querySelector("[data-range-left]");
    const dotRight = this.querySelector("[data-range-right]");
    const labelMin = this.querySelector("[data-range-label-min]");
    const labelMax = this.querySelector("[data-range-label-max]");
    const textMin = this.textInputs[0];
    const textMax = this.textInputs[1];

    const formatPrice = (reais) =>
      currencySymbol +
      " " +
      Number(reais).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    let minVal = rangeMin;
    let maxVal = rangeMax;
    if (textMin && textMin.value && !Number.isNaN(this.parseReais(textMin.value)))
      minVal = Math.max(rangeMin, Math.min(rangeMax, this.parseReais(textMin.value)));
    if (textMax && textMax.value && !Number.isNaN(this.parseReais(textMax.value)))
      maxVal = Math.max(rangeMin, Math.min(rangeMax, this.parseReais(textMax.value)));
    if (minVal > maxVal) {
      const t = minVal;
      minVal = maxVal;
      maxVal = t;
    }

    const updateUI = () => {
      const fillLeft = ((minVal - rangeMin) / range) * 100;
      const fillWidth = ((maxVal - minVal) / range) * 100;
      const fillLeftPercent = fillLeft + "%";
      const fillWidthPercent = fillWidth + "%";
      if (sliderEl) {
        sliderEl.style.setProperty("--range-fill-left", fillLeftPercent);
        sliderEl.style.setProperty("--range-fill-width", fillWidthPercent);
      }
      if (labelMin) labelMin.textContent = formatPrice(minVal);
      if (labelMax) labelMax.textContent = formatPrice(maxVal);
      if (textMin) textMin.value = this.formatReaisForInput(minVal);
      if (textMax) textMax.value = this.formatReaisForInput(maxVal);
      if (dotLeft) dotLeft.setAttribute("aria-valuenow", minVal);
      if (dotRight) dotRight.setAttribute("aria-valuenow", maxVal);
    };

    const getPercentFromEvent = (e) => {
      if (!sliderEl) return 0;
      const rect = sliderEl.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let pct = ((clientX - rect.left) / rect.width) * 100;
      return Math.max(0, Math.min(100, pct));
    };

    const setupDrag = (dot, isLeft) => {
      const onMove = (e) => {
        e.preventDefault();
        const pct = getPercentFromEvent(e);
        const reais = rangeMin + (pct / 100) * range;
        if (isLeft) {
          minVal = Math.max(rangeMin, Math.min(maxVal, reais));
        } else {
          maxVal = Math.max(minVal, Math.min(rangeMax, reais));
        }
        updateUI();
      };
      const onEnd = () => {
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onEnd);
        document.removeEventListener("touchmove", onMove, { passive: false });
        document.removeEventListener("touchend", onEnd);
    
        if (textMin) {
          const evt = new Event("input", { bubbles: true });
          textMin.dispatchEvent(evt);
        } else if (textMax) {
          const evt = new Event("input", { bubbles: true });
          textMax.dispatchEvent(evt);
        }
      };
      const onStart = (e) => {
        e.preventDefault();
        if (e.type === "mousedown") {
          document.addEventListener("mousemove", onMove);
          document.addEventListener("mouseup", onEnd);
        } else {
          document.addEventListener("touchmove", onMove, { passive: false });
          document.addEventListener("touchend", onEnd);
        }
      };
      dot.addEventListener("mousedown", onStart);
      dot.addEventListener("touchstart", onStart, { passive: false });
    };

    setupDrag(dotLeft, true);
    setupDrag(dotRight, false);

    if (textMin) textMin.addEventListener("input", () => {
      const v = this.parseReais(textMin.value);
      if (!Number.isNaN(v)) {
        minVal = Math.max(rangeMin, Math.min(maxVal, v));
        updateUI();
      }
    });
    if (textMax) textMax.addEventListener("input", () => {
      const v = this.parseReais(textMax.value);
      if (!Number.isNaN(v)) {
        maxVal = Math.max(minVal, Math.min(rangeMax, v));
        updateUI();
      }
    });

    updateUI();
  }

  onTextInputChange(event) {
    if (
      !event.currentTarget.classList.contains("ec-price-facet__input") &&
      !event.currentTarget.matches('input[type="text"]')
    )
      return;
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    const container = this.querySelector(".ec-price-facet--range") || this;
    const rangeMin = Number(container.dataset.rangeMin) || 0;
    const rangeMax = Number(container.dataset.rangeMax) || 0;
    const textMin = this.textInputs[0];
    const textMax = this.textInputs[1];
    const labelMin = this.querySelector("[data-range-label-min]");
    const labelMax = this.querySelector("[data-range-label-max]");
    const currencySymbol = container.dataset.currencySymbol || "";

    if (this.dotLeft && this.dotRight) {
      const sliderEl = this.querySelector("[data-range-slider]");
      const minReais = this.parseReais(textMin && textMin.value);
      const maxReais = this.parseReais(textMax && textMax.value);
      let minVal = Number.isNaN(minReais) ? rangeMin : Math.max(rangeMin, Math.min(rangeMax, minReais));
      let maxVal = Number.isNaN(maxReais) ? rangeMax : Math.max(rangeMin, Math.min(rangeMax, maxReais));
      if (minVal > maxVal) {
        const t = minVal;
        minVal = maxVal;
        maxVal = t;
      }
      const range = rangeMax - rangeMin || 0.01;
      const fillLeftPercent = ((minVal - rangeMin) / range) * 100 + "%";
      const fillWidthPercent = ((maxVal - minVal) / range) * 100 + "%";
      if (sliderEl) {
        sliderEl.style.setProperty("--range-fill-left", fillLeftPercent);
        sliderEl.style.setProperty("--range-fill-width", fillWidthPercent);
      }
      if (labelMin) labelMin.textContent = currencySymbol + " " + Number(minVal).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (labelMax) labelMax.textContent = currencySymbol + " " + Number(maxVal).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return;
    }

    if (this.rangeInputs.length === 2) {
      const inputMin = this.querySelector(".ec-price-facet__range-input--min");
      const inputMax = this.querySelector(".ec-price-facet__range-input--max");
      const minReais = this.parseReais(textMin && textMin.value);
      const maxReais = this.parseReais(textMax && textMax.value);

      if (!Number.isNaN(minReais) && inputMin)
        inputMin.value = Math.max(rangeMin, Math.min(rangeMax, minReais));

      if (!Number.isNaN(maxReais) && inputMax)
        inputMax.value = Math.max(rangeMin, Math.min(rangeMax, maxReais));

      const fillEl = this.querySelector("[data-range-fill]");
      const trackWrapUpdate = this.querySelector(".ec-price-facet__range-track-wrap");
      if ((fillEl || trackWrapUpdate) && inputMin && inputMax) {
        const minVal = Number(inputMin.value);
        const maxVal = Number(inputMax.value);
        const range = rangeMax - rangeMin || 0.01;
        const fillLeftPercent = ((minVal - rangeMin) / range) * 100 + "%";
        const fillWidthPercent = ((maxVal - minVal) / range) * 100 + "%";
        if (fillEl) {
          fillEl.style.setProperty("--range-fill-left", fillLeftPercent);
          fillEl.style.setProperty("--range-fill-width", fillWidthPercent);
        }
        if (trackWrapUpdate) {
          trackWrapUpdate.style.setProperty("--range-fill-left", fillLeftPercent);
          trackWrapUpdate.style.setProperty("--range-fill-width", fillWidthPercent);
        }
      }

      if (labelMin && inputMin)
        labelMin.textContent =
          currencySymbol +
          " " +
          Number(inputMin.value).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

      if (labelMax && inputMax)
        labelMax.textContent =
          currencySymbol +
          " " +
          Number(inputMax.value).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
    }
  }

  onRangeChange(event) {
    if (
      !event.currentTarget.classList.contains("ec-price-facet__input") &&
      !event.currentTarget.matches('input[type="text"]')
    )
      return;
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    if (
      !event.currentTarget.classList.contains("ec-price-facet__input") &&
      !event.currentTarget.matches('input[type="text"]')
    )
      return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const minInput = this.textInputs[0];
    const maxInput = this.textInputs[1];

    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
